import {theme} from "../../utils";


export const buttonStyles = {
    ctaTitle: {
        ...theme.typography.montseratH1,
        fontSize: "20.28px",
        fontStyle: "normal",
        color: theme.palette.primary.main,
        lineHeight: '26.4px',
        letterSpacing: '0.45px',
    },
    button: {
        mt: 0,
        pt:0,
        pl:0,
        display: "flex"
    },
    downloadIcon: {
        paddingRight: "8px",
        width: "15px",
    },
    downloadText: {
        ...theme.typography.body1Regular,
        fontSize: "15px",
        color: theme.palette.primary.main,
        textTransform: "capitalize",
        lineHeight: "150%",
        letterSpacing: "-1.5%",
    }
}


export enum DownloadButtonType {
    Download = "download",
    Pdf = "pdf",
}

export type DownloadButtonProps = {
    buttonText: string;
    fileUrl: string;
    buttonType: DownloadButtonType;
    buttonIcon:any
};
